<template>
    <modal-dialog
        v-model="dialog"
        :title="title ? title : $t('texts.are_you_sure')"
        cancel-button
        :cancel-text="cancelText"
        :ok-text="approveText"
        :ok-color="approveColor"
        :show-overlay="processing"
        @cancel="onCancel"
        @ok="onApprove"
    >
        <text-input
            v-model="folderName"
            :label="$t('texts.folder_name')"
            name="folderName"
            autocomplete="disabled"
        ></text-input>
    </modal-dialog>
</template>

<script>
import ModalDialog from '@/components/dialog/ModalDialog'
import TextInput from '@/components/form/Inputs/TextInput'

export default {
    components: {
        ModalDialog,
        TextInput,
    },
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        inputValue: {
            type: Object,
        },
        title: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        approveText: {
            type: String,
            default: null,
        },
        approveColor: {
            type: String,
            default: null,
        },
        cancelText: {
            type: String,
            default: null,
        },
        processing: {
            type: Boolean,
        },
    },
    data() {
        return {
            dialog: false,
            folderName: null,
            folderId: null,
        }
    },
    watch: {
        value() {
            this.dialog = this.value
        },
        inputValue() {
            this.folderName = this.inputValue.text
            this.folderId = this.inputValue.id
        },
    },
    methods: {
        onApprove() {
            this.$emit('input', false)
            this.$emit('onApprove', this.folderName, this.folderId)
        },
        onCancel() {
            this.$emit('input', false)
            this.$emit('onCancel')
        },
    },
}
</script>
